import { render, staticRenderFns } from "./multiple-select.vue?vue&type=template&id=354b9a65&scoped=true&"
import script from "./multiple-select.vue?vue&type=script&lang=js&"
export * from "./multiple-select.vue?vue&type=script&lang=js&"
import style0 from "./multiple-select.vue?vue&type=style&index=0&id=354b9a65&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354b9a65",
  null
  
)

export default component.exports